import React, { useEffect } from "react";
// import { Helmet } from "react-helmet-async";
import { Helmet } from 'react-helmet';

import seoData from "../data/seo.json";

const Seo = ({ path = "/" }) => {
  // Normalize path: remove trailing slash (except for root)
  let key = path;
  if (key.length > 1 && key.endsWith("/")) key = key.slice(0, -1);

  // If exact key not found, try with and without trailing slash
  const data = seoData[key] || seoData[`${key}/`] || {
    title: "ISOLS Group",
    description: "Digital Marketing Agency",
    keywords: "marketing"
  };

  // Helpful debug in development to confirm which meta set
  if (typeof process !== "undefined" && process.env && process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.debug("SEO: path=", path, "key=", key, "title=", data.title);
  }

  // Fallback: directly update document title and meta tags so SPA navigation
  // reflects immediately even if Helmet doesn't for some reason.
  useEffect(() => {
    try {
      if (data.title) document.title = data.title;

      const updateMeta = (name, value) => {
        let el = document.querySelector(`meta[name="${name}"]`);
        if (el) el.setAttribute("content", value);
        else {
          el = document.createElement("meta");
          el.setAttribute("name", name);
          el.setAttribute("content", value);
          document.head.appendChild(el);
        }
      };

      if (data.description) updateMeta("description", data.description);
      if (data.keywords) updateMeta("keywords", data.keywords);
      if (data.robots) updateMeta("robots", data.robots);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn("SEO fallback update failed:", err);
    }
  }, [key, data.title, data.description, data.keywords, data.robots]);

  return (
   <>
   <Helmet>
      <title>{data.title}</title>
      <meta name="description" content={data.description} />
      <meta name="keywords" content={data.keywords} />
      {/* <meta name="robots" content={data.robots || "index,follow"} />
      <link rel="canonical" href={(data.canonical || `https://www.isolsgroup.com${key}`)} /> */}

      {/* Open Graph / Social (optional) */}
      {/* <meta property="og:title" content={data.title} />
      <meta property="og:description" content={data.description} />
      <meta property="og:url" content={data.canonical || `https://www.isolsgroup.com${key}`} />
      {data.ogImage && <meta property="og:image" content={data.ogImage} />} */}
    </Helmet>
    </>
  );
};

export default Seo;
